// extracted by mini-css-extract-plugin
module.exports = {"container":"eRevofMbKuiSSPyyOiBSy","cancelBtn":"_1OakP9iy0XJClEajdhIdya","icon":"_3gNwA9CsuzeDom7iL2ht59","saveBtn":"_3jzrh-rzWUCD9V6GLOABXw"};